export default __webpack_public_path__ + "static/media/copyIcon.6802ea8d.svg";